module.exports = __webpack_public_path__ + "img/repguide-wartung-filter.ac43dd03.jpg";